module.exports = __webpack_public_path__ + "assets/media/attention.2857a307.svg";